// Oauth
const OAUTH_API = 'oauth-api';
const OAUTH_AUTHORIZE = 'oauth-authorize';
const OAUTH_SIGNUP = 'oauth-signup';
const OAUTH_PWDRECOVERY = 'oauth-password-recovery';
const OAUTH_PWDRECOVERY_CLOSE = 'oauth-password-recovery-close';
const OAUTH_ERROR = 'oauth-error';

export default [
  OAUTH_API,
  OAUTH_SIGNUP,
  OAUTH_PWDRECOVERY,
  OAUTH_AUTHORIZE,
  OAUTH_ERROR,
  OAUTH_PWDRECOVERY_CLOSE,
];
